module.exports = __webpack_public_path__ + "img/5.4ddcc9d3.png";